// extracted by mini-css-extract-plugin
module.exports = {"textSegments":"VerificationInstructions_textSegments__xI0wb"};